module.exports = __webpack_public_path__ + "img/2023_jeep-gladiator.391b1623.png";